import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import queryString from 'query-string';
import CancelMoveInCostsModal from './component';
import { trackValidationError } from '@common/actions/TrackingActions';
import { closeNotification, showModalNotification, showPageNotification } from '@common/actions/NotificationActions';
import { DEFAULT_ERROR, MOVE_IN_COSTS_CANCEL_SUCCESS } from '@rental-manager/constants/NotificationConstants';
import { cancelMoveInCosts, getIreneDashboard } from '@rental-manager/actions/requests';
import paths from '@rental-manager/pathsManifest';
import { getMoveInCostsDetails } from '@common/paymentsUtils/moveInCostsUtil';
import FeaturePermissionTypes from '@rental-manager/constants/FeaturePermissionTypes';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, ownProps) => {
  const rentTermsKeyFromQueryString = queryString.parse(ownProps.location.search).rentTermsKey;
  const { allTransactions, featurePermissions } = state.payments.landlord.property;
  const moveInCostsDetails = getMoveInCostsDetails(allTransactions, rentTermsKeyFromQueryString);

  const { groupKey, tenantFirstName } = moveInCostsDetails;
  const { isAllowed: isMICAllowed } =
    featurePermissions?.[rentTermsKeyFromQueryString as keyof typeof featurePermissions]?.[
      FeaturePermissionTypes.MOVE_IN_COSTS
    ] || false;
  return {
    groupKey,
    tenantFirstName,
    isMICAllowed,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  createMoveInCosts: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl + paths.dashboard.createMoveInCostsPage))),
  cancelMoveInCosts: async ({ groupKey }) => {
    try {
      await dispatch(closeNotification());
      await dispatch(cancelMoveInCosts({ propertyId, groupKey }));
      return { success: true };
    } catch (err) {
      logError({ error: err });
      dispatch(showModalNotification(DEFAULT_ERROR));
      return { error: true };
    }
  },
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl))),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl))),
  goToDashboard: async (tenantFirstName: string) => {
    await dispatch(push(baseUrl));
    await dispatch(getIreneDashboard({ propertyId }));
    await dispatch(showPageNotification(MOVE_IN_COSTS_CANCEL_SUCCESS, { tenantFirstName }));
  },
  trackValidationError: (data) => dispatch(trackValidationError(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CancelMoveInCostsModal);
